import React from 'react';
import styled, {css} from 'styled-components';
import {BLOOD, GRAY_60, LOCHMARA, PURE_WHITE, TREE_POPPY, YORK} from '../refs/Colors';
import {Icon} from './Icon';
import {ICON_X} from '../refs/Icons';
import {getColor} from '../utils/styled';

type FeedbackToastType = 'success' | 'error' | 'info' | 'warning';

type FeedbackToastProps = {
  className?: string;
  message: string;
  onClose?: () => void;
  closeAriaLabel?: string;
  type: FeedbackToastType;
};

const COLOR_FROM_TYPE: Record<FeedbackToastType, string> = {
  success: YORK,
  error: BLOOD,
  info: LOCHMARA,
  warning: TREE_POPPY,
};

const Wrapper = styled.div<{$type: FeedbackToastType}>`
  display: inline-flex;
  align-items: start;
  justify-content: space-between;
  gap: 25px;
  position: relative;
  width: 316px;
  padding: 16px;
  cursor: pointer;
  background-color: ${props => css`${getColor(COLOR_FROM_TYPE[props.$type] || GRAY_60)}`};
  border-radius: 5px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.25);

  @media (min-width: 768px) {
    width: 386px;
  }

  .feedback-toast-close {
    flex-grow: 0;
  }

`;

const Message = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  color: ${getColor(PURE_WHITE)};
  margin: 0;
  width: 100%;
  white-space: pre-wrap;
  flex-grow: 2;
`;


export const FeedbackToast: React.FC<FeedbackToastProps> = ({
  className,
  message,
  onClose,
  type = "success"
}) => {
  return (
    <Wrapper className={className} onClick={onClose} $type={type}>
      <Message>{message}</Message>
      {onClose && (
        <Icon className="feedback-toast-close" color={PURE_WHITE} size={24} fontSize={18} icon={ICON_X} clickable />
      )}
    </Wrapper>
  );
};

export default FeedbackToast;
